import {combineReducers} from "redux";
import layoutDataReducer from "./layout/data/reducer";
import layoutInteractionReducer from "./layout/interaction/Layout";
import tabReducer from "./tab/reducer";
import actionHistoryReducer from "./action-history/reducer";
import loginReducer from "./login/login";
import defaultSettingReducer from "./default-setting/reducer";
import axiosReducer from "./axios/reducer";
import formReducer from "./form/reducer";
import notificationPushReducer from "./notification-push/reducer";
import documentReducer from "./document";
import permissionTnpActionReducer from "./permission/permission";
import abilityReducer from "./ability/AbilityReducer";

const rootReducer = combineReducers({
    layoutDataReducer,
    layoutInteractionReducer,
    tabReducer,
    actionHistoryReducer,
    loginReducer,
    defaultSettingReducer,
    axiosReducer,
    formReducer,
    notificationPushReducer,
    documentReducer,
    permissionTnpActionReducer,
    abilityReducer
});

export default rootReducer;
